class Diferido{
    constructor(
        Meses,
        Intereses,
        Titulo,
        IdTipoBotonPago,
        TipoBotonPago,
        IdDiferido,
    ){
        this.Meses=Meses;
        this.Intereses=Intereses;
        this.Titulo=Titulo;
        this.IdTipoBotonPago=IdTipoBotonPago;
        this.TipoBotonPago=TipoBotonPago;
        this.IdDiferido=IdDiferido;
    }
}
export default Diferido;